/**
 *  Stick It
 *  Sticks the content of the element with the class {selector_content} to the top of the screen
 *
 *  v1.5 - 26.01.01
 *       - documentation
 *       - making it more flexible
 *       - multiple sticky elements in the same container possible
 *
 *  v1.0 - 25.09.28
 *       - initial version
 *
 */
import LeStickyHeader from "../stickyheader/le-sticky_header.js";

class LeStickyIt {

    constructor( config ) {

        const settings_default = {

            /**
             * sticky will be stuck to the top / header at this distance
             */
            sticky_margin: 16,

            /**
             * buffer for the detection in pixels, can be negative
             */
            sticky_detection_margin: 16,

            /**
             * selector for the container in which the element is located, selector will be used to find the first
             * parent of a sticky element
             */
            selector_container: '.le-right',

            /**
             * selector for the element we want to stick, can be multiple
             */
            selector_content: '.event-template-default .le-right-content',

            /**
             * Selector for the sticky header element that retracts
             */
            selector_header: 'i96-stickyheader',

            /**
             * class added to the stuck element
             */
            stuck_indicator_class: '-stuck',

            /**
             * class addet to the container of the stuck element when it is stuck
             */
            stuck_indicator_container_class: '-haz-stuck',
            /**
             * CSS variable containing the height of the header element to take into account when retracting
             */
            header_height_css_property: '--le-sticky-header-height',

            debug: false
        }

        this.settings = {
            ...settings_default,
            ...config
        }

        if (this.settings.debug === true) this.debug = true;

        if (this.debug) console.log('LeStickIt: constructor('+config+')');

        this.init();

    }

    init() {

        window.addEventListener(
            'scroll',
            () => {
                this._processScroll()
            }
        );
        this._processScroll()

        window.addEventListener(
            'resize',
            () => {
                this._processResize()
            }
        );
        this._processResize();

    }

    _checkContainer( ele_container ) {
        if (!ele_container || ele_container.length === 0) {
            if (this.debug) console.log( 'LeStickIt: no container element found', this.settings.selector_container)
            return false;
        }
        return true;
    }

    _processResize() {
        const ele_sticky = document.querySelectorAll( this.settings.selector_content );
        if (this.debug) console.log('LeStickIt: _processResize(), ' + ele_sticky.length + ' sticky elements found');

        if (ele_sticky.length === 0) {
            if (this.debug) console.log( 'LeStickIt: no sticky element found')
            return;
        }

        ele_sticky.forEach( ele => {

            if (ele.classList.contains( this.settings.stuck_indicator_class )) {

                // if stuck but window is too small, unstick
                if (window.innerWidth < 997) {
                    this.deactivateStick();
                    return;
                } else {
                    // todo init stick if necessary
                }

                // get parent with container class
                const ele_container = ele.closest( this.settings.selector_container );

                if (!this._checkContainer( ele_container )) {return;}

                ele.style.width = ele_container.getBoundingClientRect().width + 'px';
            }

        })

    }

    /**
     * Reads the css variable with the header height, or, in case it is not set,
     * reads the height of the header element.
     * @returns {number}
     */
    _getHeaderHeight() {
        let header_height = document.documentElement.style.getPropertyValue( this.settings.header_height_css_property );
        if (header_height === '') {
            header_height = document.getElementById( this.settings.selector_header ).getBoundingClientRect().height
        }
        return parseInt(header_height);
    }

    _processScroll() {
        const header_height = this._getHeaderHeight();
        const ele_sticky = document.querySelectorAll( this.settings.selector_content );

        if (this.debug) console.log('LeStickIt: _processScroll()' + ele_sticky.length + ' sticky elements');

        // for each sticky element
        ele_sticky.forEach( curr_ele_stick => {

            // get parent with container class
            const ele_container = curr_ele_stick.closest( this.settings.selector_container );
            if (!this._checkContainer( ele_container )) {return;}

            // check if we have to stick it
            if (ele_container.getBoundingClientRect().top < this.settings.sticky_detection_margin ||
                header_height > 0 && ele_container.getBoundingClientRect().top <= (header_height + this.settings.sticky_detection_margin)) {
                this.activateStick( ele_container, curr_ele_stick );
            } else {
                this.deactivateStick( ele_container, curr_ele_stick );
            }

            this.doStick( header_height, ele_container, curr_ele_stick );

        })

    }

    doStick( header_height, ele_container, ele_sticky ) {

        let new_top = 0;

        if (ele_sticky.classList.contains( this.settings.stuck_indicator_class )) {

            // check if we have to stick to the bottom
            const leright_visible_height = ele_container.getBoundingClientRect().height + ele_container.getBoundingClientRect().top;
            if ( leright_visible_height <= (ele_sticky.getBoundingClientRect().height + this.settings.sticky_detection_margin + header_height)) {
                new_top = leright_visible_height - (ele_sticky.getBoundingClientRect().height);
            } else {
                const header_height = this._getHeaderHeight();
                new_top = header_height + this.settings.sticky_margin;
            }
            ele_sticky.style.top = new_top + 'px';
        }
    }

    activateStick( ele_container, ele_sticky ) {

        if (this.debug) console.log('LeStickIt: activateStick()', ele_container, ele_sticky);

        if (ele_sticky.classList.contains( this.settings.stuck_indicator_class )) {
            return;
        }

        if (this.debug) console.log(ele_container.getBoundingClientRect());

        ele_sticky.style.position = 'fixed';
        // leright_content.style.right = leright.getBoundingClientRect().right;
        ele_sticky.style.width = ele_container.getBoundingClientRect().width + 'px';

        ele_sticky.classList.add( this.settings.stuck_indicator_class );
        ele_container.classList.add( this.settings.stuck_indicator_container_class );
    }

    deactivateStick( ele_container, ele_sticky ) {

        if (this.debug) console.log('LeStickIt: deactivateStick()', ele_container, ele_sticky);

        if (!ele_sticky || !ele_sticky.classList.contains( this.settings.stuck_indicator_class )) {
            return;
        }

        ele_sticky.style.position = 'relative';
        ele_sticky.style.top = '0';
        // leright_content.style.right = '0';
        ele_sticky.style.width = '100%';
        ele_sticky.classList.remove(  this.settings.stuck_indicator_class  );
        ele_container.classList.remove(  this.settings.stuck_indicator_container_class  );
    }


}


export default LeStickyIt